import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Row } from 'components/Containers/Row/Row';
import { TextBox } from 'components/form/TextBox';
import { DropDown } from 'components/form/DropDown';
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup';
import { Button } from 'components/form/Button';
import { ReactComponent as HideFilter } from 'style/icons/art-hide-filters.svg';
import { ReactComponent as ShowFilter } from 'style/icons/art-show-filters.svg';

const AutoInsuranceFilters = props => {
  const {
    states,
    setStates,
    datatestid,
    handleShowFilters,
    issuerList,
    checkBoxList,
    onSelectMultiQuestionOptions,
    onAutoInsuranceSearch,
  } = props;
  const { showFilters, currentIssuer, multiChoiceAnswers } = states;

  const handleEnterKeyPress = (event, showFilter) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleShowFilters(showFilter);
    }
  };

  const Filters = (
    <Row className="m-margTB0">
      <FlexContainer className="flex-container align-items-center flex-tablet-col justify-between width100">
        <div className="format35 m-format100 flex-container m-flex-column">
          <TextBox
            id={`${props?.module}-zip`}
            name="zip"
            datatestid={`${datatestid}-zipCode`}
            placeholder={'Zip code'}
            value={states.zipCode}
            onChange={e =>
              setStates({
                zipCode: e.target.value,
              })
            }
            outerClassName={'margR16 m-margT0 zipLabel'}
            maxLength={5}
          />

          <DropDown
            id="current-insurer"
            datatestid={`${datatestid ? datatestid : ''}current-insurer`}
            list={issuerList}
            value={currentIssuer}
            onChange={e =>
              setStates({
                currentIssuer: e,
              })
            }
            label={'Current Insurer'}
            defaultValue={currentIssuer}
            placeholder={'Current Insurer'}
            outerClassName="currentIssuerDropDown"
          />
        </div>

        <div className="flex-container align-items-center m-flex-column m-margT24 m-margB0 format65 m-format100">
          <CheckboxGroup
            type={'checkbox'}
            initialText={'User Status'}
            options={checkBoxList}
            values={multiChoiceAnswers}
            onChange={onSelectMultiQuestionOptions}
            datatestid={`${datatestid}-checkbox-group`}
            outerClassName="checkboxesContainer format100 margLR16"
            innerClassName="format100 pad0 flex-container margB0 justify-between checkboxgroup-ul-thinner-padding"
          />
          <Button
            datatestid={`${datatestid}-auto-insurance-offer-get`}
            mrphType="primary"
            onClick={onAutoInsuranceSearch}
            className="m-margT16 border-rad100px"
          >
            {'Update'}
          </Button>
          <Row className="text-center m-margT16 d-hide">
            <Label
              type="caption"
              color="secondary_text_light"
              className="text-center  m-margB8"
              bold
              datatestid={datatestid ? `${datatestid}-hideFilter` : null}
              tabIndex="-1"
            >
              <Label
                className="pointer m-text-14"
                onClick={() => handleShowFilters(false)}
                data-testid="aiHideFilter"
                tabIndex={'0'}
              >
                {'Hide Filters'}
                <HideFilter />
              </Label>
            </Label>
          </Row>
        </div>
      </FlexContainer>
    </Row>
  );

  const HiddenFilters = (
    <Row className="text-center m-margB8 d-hide">
      <Label
        type="caption"
        color="secondary_text_light"
        className="text-center"
        bold
        datatestid={datatestid ? `${datatestid}-hideFilter` : null}
        tabIndex="-1"
      >
        <Label
          className="pointer t-text-16"
          onClick={() => handleShowFilters(true)}
          data-testid="aiHideFilter"
          tabIndex={'0'}
        >
          {'Show Filters'}
          <ShowFilter />
        </Label>
      </Label>
    </Row>
  );
  return showFilters ? Filters : HiddenFilters;
};

export default AutoInsuranceFilters;
